
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "harbor",
  "use": "harbor-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"harbor\"><path d=\"M24.152.008V0c-.051 0-.101.003-.152.003-.05 0-.1-.003-.152-.003v.008C13.535.172 5.225 8.578 5.225 18.928 5.225 32.878 21.602 46.12 24 48c2.398-1.88 18.775-15.122 18.775-29.072 0-10.35-8.31-18.756-18.623-18.92z\" /><path d=\"M31.631 7.506a4.96 4.96 0 00-4.96 4.96c0 .621.146 1.223.355 1.771l-11.69 11.69V20.26c0-2.126 1.417-2.834 1.417-2.834l1.417 1.417v-5.668c0-1.417-.709-.709-1.417 0-4.251 4.25-4.251 4.211-4.251 7.085v9.918c0 .71.708 1.418 1.417 1.418h9.919c2.873 0 5.195-2.362 7.085-4.251.708-.709 1.417-1.4 0-1.417h-5.668l1.417 1.417s-.709 1.417-2.834 1.417H18.17l11.69-11.69c.548.208 1.15.354 1.771.354a4.96 4.96 0 100-9.92zm0 2.834a2.126 2.126 0 110 4.252 2.126 2.126 0 010-4.252z\" style=\"marker:none\" color=\"#000\" overflow=\"visible\" fill=\"#fff\" /></symbol>"
});
    sprite.add(symbol);

    export default class HarborSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="harbor" {...this.props} />;
      }
    }
  